const navHeader = document.querySelector('#nav_header');
const navbarToggle = document.querySelector('#nav_header__toggle');
const nav_header__row__button = document.querySelector('#nav_header__row__button');

navbarToggle.addEventListener('click', function() {
  this.classList.toggle('open');
  nav_header__row__button.classList.toggle('open');
  window.dispatchEvent(new Event('resize'));

  // Check if the header has the 'nav_header--atbottom' class
  if (navHeader.classList.contains('nav_header--atbottom')) {
    // Scroll by 1 pixel down to stabilize the page
    window.scrollBy(0, 1);

    // Scroll back up by 1 pixel to maintain the position
    window.scrollBy(0, -1);
  }
});

// Remove 'open' class on scroll
// window.addEventListener('scroll', function() {
//   if (nav_header__row__button.classList.contains('open')) {
//     nav_header__row__button.classList.remove('open');
//     navbarToggle.classList.remove('open'); // Optional: also close the navbar toggle button
//   }
// });